import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery'; 
import { UserDetailsService } from '../../../services/user-details.service';
import { USER_DEFAULT_CURRENCY_SYMBOL, feesTypes } from '../../config/cashier.config';
import { EmitterService } from '../../../services/emitter.service';
import { CashierService } from '../../services/cashier.service';

@Component({
  selector: 'app-transaction-breakdown',
  templateUrl: './transaction-breakdown.component.html',
  styleUrls: ['./transaction-breakdown.component.scss']
})
export class TransactionBreakdownComponent implements OnInit {

  intialAmount = 0;
  feesAmount:any = 0;
  totalAmount:any = 0;
  feesType =feesTypes.FEES_TYPE_NONE;
  paymentMethod;
  userCurrency = USER_DEFAULT_CURRENCY_SYMBOL;
  isShowBreakDownDetails = false;
  constructor(private userDetailsService:UserDetailsService, private emitterService:EmitterService, private cashierService:CashierService) { 

  this.emitterService.updateAmountInTransactionBreakdown$.subscribe((data:any)=>{
    if(data && data.method){
      this.paymentMethod = data.method
    }
    this.paymentMethodChange(data.amount)
  })
  this.emitterService.statusCall$.subscribe((status) =>{
    if(status == 'updated')
    this.userCurrency = this.userDetailsService.getUserCurrencySymbol();
  });

  this.emitterService.onChangePaymentMethod$.subscribe((newMethod) => {
      this.paymentMethod = newMethod;
  });
  }

  ngOnInit(): void {
    this.userCurrency = this.userDetailsService.getUserCurrencySymbol();
  }
 
  openTransactionBreakdown(){
   this.isShowBreakDownDetails = !this.isShowBreakDownDetails; 
  }

  paymentMethodChange(selectedAmount){
    selectedAmount = selectedAmount ? selectedAmount : 0
      this.intialAmount = parseFloat(selectedAmount);
      this.feesType = this.paymentMethod?.feeType;
      this.feesAmount = parseFloat(this.paymentMethod?.feeAmount);
      this.calculateTotalAmount();
  }
  calculateTotalAmount(){
    if(!this.feesAmount){
      this.totalAmount = this.intialAmount;
      return this.totalAmount
    }
   
    if(this.feesType == feesTypes.FEES_TYPE_ABSOLUTE){
       this.totalAmount = this.intialAmount + this.feesAmount;
    }else if(this.feesType == feesTypes.FEES_TYPE_PERCENTAGE){
      this.feesAmount = ((this.feesAmount/ 100) * this.intialAmount).toFixed(2);
      if(this.paymentMethod.maxFeesAmount && this.paymentMethod.maxFeesAmount < this.feesAmount){
        this.feesAmount = this.paymentMethod.maxFeesAmount;
      }else if(this.paymentMethod.minFeesAmount && this.paymentMethod.minFeesAmount >= this.feesAmount){
        this.feesAmount = this.paymentMethod.minFeesAmount;
      }
      this.totalAmount = (this.intialAmount + parseFloat(this.feesAmount));
    }
    this.cashierService.totalAmount = this.totalAmount;
  }
}
